<template>
<b-row class="tool-header no-gutters">
  <b-col class="reduce-padding" cols="12">
    <div class="header-area email-font">
      <div v-if="image !== 'background'" class="common-img-cover" :class="{'home-img-cover': image == 'menu', 'bg-img-cover': image == 'background', 'triggers-img-cover': image == 'triggers' , 'risk-img-cover': image == 'riskFactors'
        , 'summary-img-cover': image == 'summary', 'email-img-cover': image == 'email'}">
        <div class="common-image" :class="{'home-image': image == 'menu', 'microscope-pic': image == 'background',  'triggers-image': image == 'triggers' ,  'risk-image': image == 'riskFactors'
           ,  'summary-image': image == 'summary'  ,  'email-image': image == 'email'}"></div>
      </div>
      <div v-if="image !== 'background'" class="header-text"> {{screenTitle}}</div>
      <b-row class=" no-gutters" v-if="image == 'background'">


        <b-col class="reduce-padding" cols="12" sm="8">
          <div class="common-img-cover" :class="{'home-img-cover': image == 'menu', 'bg-img-cover': image == 'background'}">
            <div class="common-image" :class="{'home-image': image == 'menu', 'microscope-pic': image == 'background'}"></div>
          </div>
          <div class="header-text"> {{screenTitle}}</div>
        </b-col>

        <b-col class="reduce-padding" cols="12" sm="4">
          <div class="right-col">
            <div class="common-img-cover">
              <a href="https://www.thyroideyes.com/about-thyroid-eye-disease/phases-of-ted" target="_blank">
                <div class="question-mark-logo"></div>
              </a>
            </div>

            <div class="header-right-text"> <a href="https://www.thyroideyes.com/about-thyroid-eye-disease/phases-of-ted" target="_blank">What are the 2 Phases of TED?</a></div>

          </div>
        </b-col>

      </b-row>
    </div>
  </b-col>

</b-row>
</template>

<script>

  export default {
    name: "tedtfHeader",
    components: {},

    data() {
      return {};
    },
    
    props: {
        screenTitle: {
          default: '',
            type: String
        },
        
        image: {
          type: String
        }
    },
  };
</script>


<style lang="scss" scoped>

</style>